import Checkbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import TextField from "@mui/material/TextField"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import type { ProductOperatorActionFormValues } from "../../schemas"

import { TEXT_AREA_STYLING_PROPS } from "@/constants/forms"

export const ProductOperatorActionForm: FC = () => {
  const { control } = useFormContext<ProductOperatorActionFormValues>()

  return (
    <>
      <Controller
        name='isOperatorActionRequired'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                data-testid='is-operatior-action-required-checkbox'
              />
            }
            label='Is Operator Action Required'
          />
        )}
      />
      <Controller
        name='operatorActionDescription'
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            {...TEXT_AREA_STYLING_PROPS}
            id='operator-action-description-input'
            data-testid='operator-action-description-input'
            placeholder='Add note...'
            minRows={3}
            className='mt-6'
          />
        )}
      />
    </>
  )
}
